import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {LoginService} from '../components/login/login.service';
import {GuestAccountError} from '../models/guest-account-error.model';

// CanActivate ist als deprecated markiert, deswegen CanActivateFn
/**
 * Dieser Guard sperrt eine Route für SSO-Gast-Accounts.
 *
 * Nötig für Seiten, die selbst keinen identitätspflichtigen Backend-Aufruf auslösen — /customer zeigt
 * z. B. nur statische Texte und eine Kachel. Dort entsteht kein 403, an dem der
 * `GuestAccountInterceptor` die Info-Seite einblenden könnte.
 *
 * Ob ein Account ein Gast ist, weiß das Frontend nicht von sich aus; einzige Quelle ist die Antwort
 * des Backends. Der Guard fragt deshalb die Nutzerdaten ab: für Gast-Accounts antwortet das Backend
 * mit 403, woraufhin der Interceptor auf die Info-Seite umleitet. `getUserData()` ist nach dem ersten
 * Laden gecacht und kostet regulären Nutzern damit keinen zusätzlichen Aufruf.
 */
export const GuestAccountGuard: CanActivateFn = (): Observable<boolean> => {
  const loginService = inject(LoginService);

  return loginService.getUserData().pipe(
    map(() => true),
    catchError((error: unknown) => {
      if (GuestAccountError.isGuestAccountError(error)) {
        // Die Umleitung auf die Info-Seite hat der GuestAccountInterceptor bereits ausgelöst.
        return of(false);
      }
      // Andere Fehler dürfen die Seite nicht sperren - sie werden an der jeweiligen Ladestelle behandelt.
      console.error('guest-account-guard: Nutzerdaten konnten nicht geladen werden', error);
      return of(true);
    })
  );
};
